import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useDrodDetailModel } from "../drodDetailModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import moment from "moment";
import { salesService } from "@/views/sales/salesService";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useDrodDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);
    const { user: { userName }, } = useGlobalModel(({ user }) => [user])
    const { fetchCustomerList, fetchSalesList, beShopDs } = useGlobalModel(({ beShopDs }) => [beShopDs]);
    const { getSelectedDictOne } = useDictModel(() => []);

    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            // customerId: retData.id,
            // phone: retData.phone,
            // contact: retData.contact,
            // countryCode: retData.countryCode,
            // countryName: retData.countryName
        }
        updateFormVal(mode, data);
    }

    //回显选中外贸合同信息
    const getSale = async (id: string) => {
        let { retData } = await salesService.one(id);
        let data = {
            bentityCode: retData.bentityCode,
            bentityName: retData.bentityName,
            customerCode: retData.customerCode,
            customerName: retData.customerName,
            relevanceOrderId: retData.relevanceOrderId,
        }
        updateFormVal(mode, data);
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //客户选中
    const saleCodeChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getSale(option.id as string)
        }
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退税单据号",
                fieldName: "code",
                disable: true,
            }, {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                selectfetchList: fetchSalesList,
                onSelectChange: saleCodeChange,
                rules: [{ required: true, message: "请选择外贸合同号" }],
                disable: editFormVal.status === "drawback-status.wait" || formVal.status === 'drawback-status.finish',
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务员",
                fieldName: "createUser",
                disable: true,
                // rules: [{ required: true, message: "请输入业务员" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                rules: [{ required: true, message: "请选择销售实体" }],
                disable: editFormVal.status === "drawback-status.wait" || formVal.status === 'drawback-status.finish',
            }, {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "客户名称",
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "客户",
                rules: [{ required: true, message: "请选择客户" }],
                selectfetchList: fetchCustomerList,
                defaultQuery: formVal.customerName,
                disable: editFormVal.status === "drawback-status.wait" || formVal.status === 'drawback-status.finish',
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "提交单据日期",
                fieldName: "createTime",
                format: "YYYY-MM-DD",
                // disable: false
                disable: editFormVal.status === "drawback-status.wait" || formVal.status === 'drawback-status.finish',
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "是否完成退税",
                fieldName: "isDrawback",
                options: [
                    { label: '是', value: 0 },
                    { label: '否', value: 1 },
                ],
                disable: editFormVal.status !== "drawback-status.wait",
                rules: [{ required: editFormVal.status === "drawback-status.wait", message: "请选择是否完成退税" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "退税日期",
                format: "YYYY-MM-DD",
                fieldName: "drawbackTime",
                disable: editFormVal.status !== "drawback-status.wait",
                rules: [{ required: editFormVal.status === "drawback-status.wait", message: "请选择退税日期" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退税金额",
                fieldName: "drawbackAmount",
                prefix: "￥",
                disable: editFormVal.status !== "drawback-status.wait",
                rules: [{ required: editFormVal.status === "drawback-status.wait", message: "请输入退税金额" }, { pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }],
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "实体名称",
                fieldName: "bentityName",
                hidden: true
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: {
            ...formVal
        },
        disabled: formVal.status === 'drawback-status.finish',
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}